import { GameParams } from "supercell-frontend-base/src/validation/game-params";
import { z } from "zod";

const stringBooleanToBoolean = (val: unknown) => {
    if (!val) {
        return undefined;
    }
    return val == "true";
};

export const SquadBustersGameParamsSchema = GameParams.and(
    z.object({
        youngPlayer: z.preprocess(
            stringBooleanToBoolean,
            z.boolean().optional(),
        ),
    }),
);

export type SquadBustersGameParams = z.infer<
    typeof SquadBustersGameParamsSchema
>;
